
import { useEffect, useRef, useState } from 'react';

const infoItems = [
  {
    icon: 'ri-phone-line',
    label: 'Phone',
    value: '0411 164 144',
    href: 'tel:0411164144',
  },
  {
    icon: 'ri-mail-line',
    label: 'Email',
    value: 'hello@houseoffmr.com',
    href: 'mailto:hello@houseoffmr.com',
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Location',
    value: 'Melbourne, Victoria, Australia',
    href: null,
  },
  {
    icon: 'ri-time-line',
    label: 'Hours',
    value: 'Mon – Sat: 9am – 6pm',
    href: null,
  },
];

export default function ContactInfo() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      {infoItems.map((item, i) => (
        <div
          key={item.label}
          className={`bg-white rounded-2xl p-6 shadow-sm border border-stone-100 flex items-start gap-4 transition-all duration-700 ease-out ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: `${i * 120}ms` }}
        >
          <div className="w-11 h-11 flex items-center justify-center rounded-full bg-amber-50 border border-amber-200 flex-shrink-0">
            <i className={`${item.icon} text-amber-600 text-lg`}></i>
          </div>
          <div>
            <p className="text-xs text-stone-400 uppercase tracking-wider mb-1">{item.label}</p>
            {item.href ? (
              <a
                href={item.href}
                className="text-stone-800 font-medium text-sm hover:text-amber-600 transition-colors cursor-pointer"
              >
                {item.value}
              </a>
            ) : (
              <p className="text-stone-800 font-medium text-sm">{item.value}</p>
            )}
          </div>
        </div>
      ))}

      {/* Social links */}
      <div
        className={`sm:col-span-2 bg-white rounded-2xl p-6 shadow-sm border border-stone-100 transition-all duration-700 ease-out ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
        style={{ transitionDelay: '480ms' }}
      >
        <p className="text-xs text-stone-400 uppercase tracking-wider mb-4">Follow Us</p>
        <div className="flex gap-3">
          {[
            { icon: 'ri-instagram-line', label: 'Instagram', href: '#' },
            { icon: 'ri-facebook-line', label: 'Facebook', href: '#' },
            { icon: 'ri-pinterest-line', label: 'Pinterest', href: '#' },
          ].map((s) => (
            <a
              key={s.label}
              href={s.href}
              rel="nofollow"
              aria-label={s.label}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-stone-100 text-stone-500 hover:bg-amber-500 hover:text-white transition-all cursor-pointer"
            >
              <i className={s.icon}></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
